import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode, unEntity } from '../../../utils/html'
import { ActionProps, BGColors, ImageSizesProps } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import { FeaturedContentBlockClassNames } from './featuredContentBlock.state'

export const fcBlockClasses: FeaturedContentBlockClassNames = {
  // DEFAULTS
  block: 'block block--featured',
  inview: 'inview',
  inner: 'block__inner ls-container--l ls-gutter ls-spacing--s',
  header: 'block__header',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro',
  content: 'block__content',
  visual: 'block__visual',
  image: 'block__image',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button button button--tertiary',
  
  // BLOCK SPECIFIC
  blockLeft: 'block--featured-left',
  blockRight: 'block--featured-right',
  layoutLeft: 'block__layout ls-gutter ls-spacing',
  layoutRight: 'block__layout ls-gutter ls-spacing'
}

export const FeaturedContentBlockLayout = {
  ColorSchemeClassName: (bgColour?: BGColors) => {
    let colorScheme: string = 'featured--lightred'
    return colorScheme;
  },
  Inner: (props: { amountNested: number; children?: React.ReactNode, imagePosition: 'left' | 'right' }): JSX.Element => {
    const { children, amountNested, imagePosition } = props
    return (
      <div className={getClassNameModern(fcBlockClasses, 'inner', 'mw-container-m mx-auto px-gutter')}>
        <div className={getClassNameModern(fcBlockClasses, imagePosition === 'left' ? 'layoutLeft' : 'layoutRight', 'row')}>{children}</div>
      </div>
    )
  },
  Content: (props: {
    label?: string
    title?: string
    intro?: string
  } & ActionProps) => {
    const { label, title, intro, showPrimary, showSecondary, primaryAction, secondaryAction } =
      props
    return (
      <>
        <div className={getClassNameModern(fcBlockClasses, 'content', 'col-12 col-md-6')}>
          {(title || label) && (
            <header className={getClassNameModern(fcBlockClasses, 'header', '')}>
              {label && (
                <p className={getClassNameModern(fcBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
                  {label}
                </p>
              )}

              {title && (
                <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(fcBlockClasses, 'title', 'h2 mb-3')}>
                  {title}
                </h2>
              )}
            </header>
          )}
          {intro && (
            <div
              className={getClassNameModern(fcBlockClasses, 'intro', 'text--styled')}
              dangerouslySetInnerHTML={{ __html: unEntity(intro) }}
            />
          )}
          {(showPrimary || showSecondary) && (
            <footer className={getClassNameModern(fcBlockClasses, 'footer', 'pt-5')}>
              {primaryAction && primaryAction.title && primaryAction.url && (
                <div className={getClassNameModern(fcBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}>
                  <SharedBlockLayout.Clickable
                    id='fcPrimaryAction'
                    type='button'
                    link={primaryAction}
                    classNames={getClassNameModern(fcBlockClasses, 'clickablePrimary', 'btn btn-primary btn-sm')}
                  />
                </div>
              )}
              {secondaryAction && secondaryAction.title && secondaryAction.url && (
                <div
                  className={getClassNameModern(
                    fcBlockClasses,
                    'clickableWrapper',
                    'd-block d-sm-inline-block ms-sm-3 mt-3 mt-sm-0'
                  )}
                >
                  <SharedBlockLayout.Clickable
                    id='fcSecondaryAction'
                    type='button'
                    link={secondaryAction}
                    classNames={getClassNameModern(
                      fcBlockClasses,
                      'clickableSecondary',
                      'btn btn-outline-primary btn-sm'
                    )}
                  />
                </div>
              )}
            </footer>
          )}
        </div>
      </>
    )
  },
  Visual: (props: { image?: ImageSizesProps['image']; imagePosition: 'left' | 'right' }) => {
    const { image, imagePosition } = props
    return (
      <>
        {image && (
          <div
            className={getClassNameModern(
              fcBlockClasses,
              'visual',
              `col-12 col-md-6 ${imagePosition == 'left' ? 'order-first mb-5 mb-md-0 ' : 'order-last mt-5 mt-md-0 '}`
            )}
          >
            <SharedBlockLayout.ModernImageSrcSet
              image={image}
              lazyload={true}
              priority={undefined}
              classNames={getClassNameModern(fcBlockClasses, 'image', 'w-100')}
              imageProportions={{
                width: '596',
                height: '447'
              }}
            />
          </div>
        )}
      </>
    )
  },
}
